import { render, staticRenderFns } from "./SvgIcon.vue?vue&type=template&id=6dee0262&"
import script from "./SvgIcon.vue?vue&type=script&lang=ts&"
export * from "./SvgIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports